import React from "react";

import { ChevLeftIcon } from "@/assets/icons";
import AdminAreaSelection from "@/components/adminAreaSelection";
import { useAppFeatures } from "@/hooks/useAppFeatures";
import { AdminAreaSettings } from "@/types/spatial";

interface PoiAdminAreaPanelProps {
  onBack: () => void;
  localAdmAreaSetting: AdminAreaSettings | null;
  setLocalAdmAreaSetting: (setting: AdminAreaSettings | null) => void;
  localAdmAreaIds: string[];
  setLocalAdmAreaIds: (ids: string[]) => void;
}

export const PoiAdminAreaPanel: React.FC<PoiAdminAreaPanelProps> = ({
  onBack,
  localAdmAreaSetting,
  setLocalAdmAreaSetting,
  localAdmAreaIds,
  setLocalAdmAreaIds
}) => {
  const { isAdminTreeEnabled } = useAppFeatures();

  const adminTreeConfig = {
    className: "flex-1 min-h-0 max-h-none",
    enabled: isAdminTreeEnabled,
    selectedIds: localAdmAreaIds,
    setSelectedIds: setLocalAdmAreaIds
  };

  const handleAdminAreaChange = (admAreaSetting: AdminAreaSettings | null) => {
    setLocalAdmAreaSetting(admAreaSetting);
  };

  return (
    <div className="bg-white-smoke p-4 rounded-xl flex flex-col flex-1 min-h-0">
      {/* Header */}
      <div className="flex items-center gap-2">
        <button
          className="cursor-pointer bg-transparent border-0 p-0"
          onClick={onBack}
        >
          <ChevLeftIcon className="w-5 h-5 fill-txtHeading" />
        </button>
        <h3 className="text-base font-semibold text-txtHeading">
          Administrative Area
        </h3>
      </div>

      {/* Content */}
      <div className="flex flex-col flex-1 min-h-0">
        <AdminAreaSelection
          selectedData={localAdmAreaSetting}
          onSelectData={handleAdminAreaChange}
          treeConfig={adminTreeConfig}
          options={{
            showCountryLevel: false,
            showLabelAboveInput: false,
            showLabel: true,
            prefixLabel: "Select",
            showTitle: false
          }}
        />
      </div>
    </div>
  );
};
